export enum PayoutStatus {
  Charged = 'charged',
  CheckPaid = 'check_paid',
  Paid = 'paid'
}
